module.exports = __webpack_public_path__ + "img/sixpackcarrier103.d463e564.jpg";